import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P00058SeuilTemperatureFiltration2424 } from '../../../Enum/P00058SeuilTemperatureFiltration2424';

@Component({
  selector: 'app-p00058-pompe-mise-en-oeuvre-proliferation-bacterienne',
  templateUrl:
    './p00058-pompe-mise-en-oeuvre-proliferation-bacterienne.component.html',
  styleUrls: [
    './p00058-pompe-mise-en-oeuvre-proliferation-bacterienne.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00058PompeMiseEnOeuvreProliferationBacterienneComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058SeuilTemperatureFiltration2424 =
    P00058SeuilTemperatureFiltration2424;
}
